// extracted by mini-css-extract-plugin
export default {"container":"sidebar_container__nsVY6","items-wrapper":"sidebar_items-wrapper__RFuUF"};